import { Container, Box, Button, Grid, Typography } from "@material-ui/core";
import React, { Fragment, useContext, useEffect, useState } from "react";
import BreadCrumbs from "../../components/BreadCrumbs";
import { listOfTwoWeeks } from "../../lib/dateCalculate";
import { AuthContext } from "../../auth/AuthContext";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import { httpGet, httpPost } from "../../lib/apiClients";
import { AxiosResponse } from "axios";
import StaffTable from "../../components/support/staff/StaffTable";
import TimeRange from "../../components/support/staff/TimeRange";
import BuyTicketWrapper from "../../components/BuyTicketWrapper";
import { getCurrentHour } from "../../utils/dateUtils";
import LoaderComponent from "../../components/LoaderComponent";
import ErrorModal from "../../components/ToastModal";
import { ThemeContext } from "../../context/ThemeContext";
import SectionHeader from "../../components/SectionHeader";
import { Environment } from "../../utils/environments";
import { ArrowBack } from "@material-ui/icons";
import ReservationChangeModal from "../../components/ReservationChangeModal";
import { UserDataContext } from "../../context/UserDataContext";
import BreadCrumbLinks from "../../components/BreadCrumbLinks";
import { setAnalyticsData } from "../../utils/firebaseLog";
import useFetchSaleTickets from "../../hooks/useFetchSaleTickets";

export default function Staff() {
  const { state } = useLocation();
  const dates = listOfTwoWeeks();
  const [reservationSchedule, setReservationSchedule] = useState<
    any | undefined
  >(undefined);
  const { businessHolidayData, memberData, setUserData, fetchUserData } =
    useContext(UserDataContext);
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [timeHr, setTimeHr] = useState([9, 10, 11, 12]);
  const [timeRange, setTimeRange] = useState<string>();
  const [selectedDate, setSelectedDate] = useState<string>(dates[0].dateYear);
  const [transformSchedule, setTransformSchedule] = useState<any | undefined>(
    undefined
  );
  const [reservationDateChangePage, setReservationDateChangePage] =
    useState<boolean>(false);
  const [ticketData, setTicketData] = useState<any>();
  const [activeDate, setActiveDate] = useState<string>("");
  const [modal, setModal] = useState<boolean>(false);
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [staffAssignError, setStaffAssignError] = useState<boolean>(false);
  const [modalData, setModalData] = useState<any>({ open: false });
  const [loading, setLoading] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const { getPurchaseList } = useContext(ThemeContext);
  const [purchaseList, setPurchaseList] = getPurchaseList;
  const [searchParams, setSearchParams] = useSearchParams();
  const currentHour = getCurrentHour();
  const ticketNumber = searchParams.get("ticketNumber")
    ? searchParams.get("ticketNumber")
    : undefined;
  const productId = searchParams.get("productId") ?? undefined;
  const { saleTickets, fetchSaleTickets } = useFetchSaleTickets();
  const [supportTicket, setSupportTicket] = useState<any>(undefined);
  useEffect(() => {
    if (currentUser === undefined) {
      return;
    }
    if (!currentUser) {
      navigate("/login", { state: { from: window.location.pathname } });
      return;
    }
    if (!ticketNumber) {
      if (!productId) {
        navigate("/support/menu");
        return;
      }
      if (!saleTickets) {
        fetchSaleTickets();
      }
    }
    document.title = "相談員日時選択 | じぶん専用IT相談室";
    if (ticketNumber) {
      document.title = "予約日時変更 | じぶん専用IT相談室";
    }

    if (state && state.displayToast == true) {
      setStaffAssignError(true);
    }
    setTimeRange("9-13");
    setTimeHr([9, 10, 11, 12]);
    var date = dates[0].dateYear;
    if (businessHolidayData) {
      if (ticketNumber) {
        getTicketData(date);
        return;
      }
      if (supportTicket) {
        setReservationDateChangePage(true);
        getReservationData(date);
      }
    }
  }, [currentUser, businessHolidayData, supportTicket]);

  useEffect(() => {
    if (!ticketNumber && saleTickets && productId) {
      const matchedTicket = saleTickets.find(
        (ticket: any) => ticket.productId === productId
      );
      if (!matchedTicket) {
        navigate("/support/menu");
      } else {
        setSupportTicket(matchedTicket);
      }
    }
  }, [saleTickets]);

  useEffect(() => {
    if (reservationSchedule) {
      setCurrentTimeRange();
      if (!reservationSchedule.isFirstCall) {
        changeTimeRange("9-13");
      }
    }
  }, [reservationSchedule]);

  function removeHolidaySelection(data) {
    var obj = { ...data };
    var currentSelectedDate = data.currentDate;
    var isHoliday = businessHolidayData.businnesHoliday
      .map((e) => e.ymd)
      .indexOf(parseInt(currentSelectedDate));
    if (isHoliday >= 0) {
      let staffSch = data.staffSchedules;
      let noAsSch = disableTimeRange(data.noAssignSchedules);
      for (const i of staffSch) {
        disableTimeRange(i.schedules);
      }
      obj = {
        ...data,
        staffSchedules: staffSch,
        noAssignSchedules: noAsSch,
      };
    }
    return obj;
  }
  function disableTimeRange(obj) {
    for (let key in obj) {
      obj[key] = false;
    }
    return obj;
  }
  function setCurrentTimeRange() {
    var currentTimeRange = "";
    if (reservationSchedule.selectTime == "MORNING") {
      currentTimeRange = "9-13";
    } else if (reservationSchedule.selectTime == "AFTERNOON") {
      currentTimeRange = "13-17";
    } else if (reservationSchedule.selectTime == "NIGHT") {
      currentTimeRange = "17-21";
    } else {
      currentTimeRange = "9-13";
    }
    changeTimeRange(currentTimeRange);
  }
  const getTicketData = async (date) => {
    try {
      await httpGet({
        pathName: "ticket-data",
        queryParams: {
          ticketNumber: ticketNumber,
          action: "CHANGE_RESERVATION",
        },
      }).then((response: AxiosResponse<any>) => {
        var data = response.data;
        console.log(data);
        setTicketData(data);
        getReservationData(date, data.minutesToSupport);
        setReservationDateChangePage(true);
      });
    } catch (error) {
      console.log(
        error.response.data.message,
        error.response.data.message.includes("RESERVATION_TIMEOUT")
      );
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
      if (
        error.response.status >= 400 &&
        error.response.status <= 499 &&
        error.response.data.message.includes("RESERVATION_TIMEOUT")
      ) {
        navigate(`/error?code=RESERVATION_TIMEOUT`);
      } else if (error.response.status >= 400 && error.response.status <= 499) {
        navigate(`/error?code=400`);
      } else {
        navigate(`/error?code=${error.response?.status}`);
      }
    }
  };
  /**
   * Get reservation data for a specific date
   * @param {string} date
   */
  const getReservationData = async (
    date,
    minutesToSupport: any = false,
    isFirstCall: any = true
  ) => {
    setActiveDate(`dt-${date}`);
    try {
      var totalMinutes = supportTicket && supportTicket.minutesToSupport;
      if (minutesToSupport) {
        totalMinutes = minutesToSupport;
      }
      var params = {
        dt: date,
        minutesToSupport: totalMinutes,
      };
      if (ticketNumber) {
        params["updateTargetTicketNumber"] = ticketNumber;
      }
      await httpGet({
        pathName: "reservation-schedule",
        queryParams: {
          ...params,
        },
      }).then((response: AxiosResponse<any>) => {
        var data = response.data;
        if (data.selectDate != date && isFirstCall) {
          setSelectedDate(data.selectDate.toString());
          getReservationData(data.selectDate, minutesToSupport);
          return;
        }
        var rData = {
          ...data,
          isFirstCall: isFirstCall,
          currentDate: date,
        };
        rData = removeHolidaySelection(rData);
        setReservationSchedule(rData);
        if (Environment.getBuildType() != "prod") {
          console.log(data);
        }
      });
    } catch (error) {
      if (error.response.data.message.includes("minutesToSupport None")) {
        navigate("/support/menu");
      } else {
        navigate(`/error?code=${error.response?.status}`);
      }
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
    } finally {
      setTableLoader(false);
    }
  };
  /**
   * Submit a schedule if it is available
   * @param {boolean} isAvailable - Indicates whether the schedule is available or not
   * @param {object} staffInfo - Information about the staff
   * @param {string} date - The selected date
   * @param {string} time - The selected time
   */
  async function submitSchedule(isAvailable, staffInfo, date, time) {
    if (!isAvailable) {
      return;
    }
    if (ticketNumber) {
      setModal(true);
      console.log(staffInfo);
      setModalData({
        staffInfo,
        date: date,
        time: time,
        minutesToSupport: ticketData && ticketData.minutesToSupport,
        ticketNumber: ticketNumber,
        productName: ticketData && ticketData.productName,
      });
    } else {
      navigate(`/buy?productId=${supportTicket.productId}`, {
        state: {
          productId: supportTicket.productId,
          ticket: supportTicket,
          staffInfo,
          date: date,
          time: time,
        },
      });
    }
  }
  async function changeReservationDate(staffInfo, date, time) {
    if (loading) {
      return;
    }
    setLoading(true);
    var params = {
      ticketNumber: ticketNumber,
      staffId: staffInfo.staffId ? staffInfo.staffId : "",
      reservationTime: `${
        ticketData.reservationTime.split("-")[0]
      }-${date}-${time}`,
      minutesToSupport: ticketData.minutesToSupport,
    };
    try {
      await httpPost({
        pathName: "update-resevation-date",
        bodyParams: {
          ...params,
        },
      }).then((response: AxiosResponse<any>) => {
        var data = response.data;
        if (Environment.getBuildType() != "prod") {
          console.log(data);
        }
        if (response.status == 200) {
          setAnalyticsData({
            eventName: "changeReseravtionDate",
            params: {
              memberId: memberData?.memberId,
            },
          });
          setPurchaseList(undefined);
          setUserData(null);
          fetchUserData();
          navigate("/reservationdate-change-complete");
        }
      });
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
      if (error.response.status >= 400 && error.response.status <= 499) {
        setModal(false);
        setErrorModal(true);
      } else {
        navigate(`/error?code=${error.response?.status}`);
      }
    } finally {
      setLoading(false);
    }
  }
  /**
   * Change the selected date and fetch the corresponding reservation data
   * @param {string} date - The new selected date
   */
  function changeDate(date: string) {
    // document.querySelector(".dates-select")?.classList.remove("select-active");
    setTableLoader(true);
    setSelectedDate(date);
    setTransformSchedule({ ...transformSchedule, ifAnyStaffAvailable: true });
    if (ticketNumber) {
      getReservationData(date, ticketData.minutesToSupport, false);
    } else {
      getReservationData(date, false, false);
    }
  }
  /**
   * Change the selected time range and update the schedule
   * @param {string} range - The new selected time range
   */
  function changeTimeRange(range) {
    setTimeRange(range);
    setTimeHr([9, 10, 11, 12]);

    var noAssignscheduleList = {
      ...reservationSchedule.noAssignSchedules,
    };
    var staffScheduleList = JSON.parse(
      JSON.stringify(reservationSchedule.staffSchedules)
    );
    var timerange = { start: "09-00", end: "13-00" };

    if (range == "13-17") {
      setTimeHr([13, 14, 15, 16]);
      timerange = { start: "13-00", end: "17-00" };
    } else if (range == "17-21") {
      setTimeHr([17, 18, 19, 20]);
      timerange = { start: "17-00", end: "21-00" };
    }
    const isAvailableAnyTime = checkAvailabilityForTheDay(noAssignscheduleList);
    noAssignscheduleList = filterTimeRange(noAssignscheduleList, timerange);
    const ifAnyStaffAvailable: any = [];

    ifAnyStaffAvailable.push(isAvailableAnyTime);
    for (var i of staffScheduleList) {
      i.isAvailableAnyTime = checkAvailabilityForTheDay(i.schedules);
      ifAnyStaffAvailable.push(i.isAvailableAnyTime);
      i.schedules = filterTimeRange(i.schedules, timerange);
      if (i.staffGender == "MALE") {
        i.staffGender = "男性";
      }
      if (i.staffGender == "FEMALE") {
        i.staffGender = "女性";
      }
      i.staffRatio = Math.floor(
        ((i.supportCompleteCount - i.supportUnSolvedCount) /
          i.supportCompleteCount) *
          100
      );
      if (i.staffRatio == 0) {
        i.staffRatio = 50;
      }
      if (Number.isNaN(i.staffRatio)) {
        i.staffRatio = 0;
      }
    }
    if (Environment.getBuildType() != "prod") {
      console.log(reservationSchedule);
    }
    var obj = {
      noAssignSchedules: noAssignscheduleList,
      isAvailableAnyTime: isAvailableAnyTime,
      staffSchedules: staffScheduleList,
      ifAnyStaffAvailable: ifAnyStaffAvailable.includes(true),
    };
    if (Environment.getBuildType() != "prod") {
      console.log(obj);
    }
    setTransformSchedule(obj);
  }
  function checkAvailabilityForTheDay(list) {
    const isAvailableAnyTime: any = [];
    for (const key in list) {
      isAvailableAnyTime.push(list[key]);
    }
    if (isAvailableAnyTime.includes(true)) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * Filter a list of schedules based on a time range
   * @param {object} list - The list of schedules to filter
   * @param {object} range - The time range to filter the schedules with
   * @returns {object} - The filtered schedules
   */
  function filterTimeRange(list, range) {
    const filteredAvailability = {};

    for (const key in list) {
      if (key >= range.start && key < range.end) {
        filteredAvailability[key] = list[key];
      }
    }
    const sortedObj = Object.fromEntries(
      Object.entries(filteredAvailability).sort(([keyA], [keyB]) =>
        keyA.localeCompare(keyB)
      )
    );
    return sortedObj;
  }

  return (
    <Fragment>
      <BreadCrumbLinks currentPage={"日時/相談員を選ぶ"} />
      <Box className="section staff-page bg-dots">
        {ticketNumber ? (
          <Fragment>
            {ticketData && (
              <Fragment>
                <SectionHeader
                  currentPage={"日時/相談員を選ぶ"}
                  preHeading={"Schedule"}
                />
                <Container style={{ marginBottom: "100px" }}>
                  <BuyTicketWrapper
                    product={ticketData}
                    state={state}
                    couponData={undefined}
                    staffData={ticketData.staff}
                    dateChangePage={true}
                  />
                </Container>
              </Fragment>
            )}
          </Fragment>
        ) : (
          <BreadCrumbs
            currentPage={"日時/相談員を選ぶ"}
            preHeading="Schedule"
          />
        )}
        {transformSchedule && reservationDateChangePage ? (
          <Container className="container">
            {/* {!ticketNumber && (
              <Box className="back-btns">
                <Link to={"/support/menu"}>
                  <Button variant="outlined" startIcon={<ArrowBack />}>
                    チケットを選ぶ
                  </Button>
                </Link>
              </Box>
            )} */}

            <TimeRange
              dates={dates}
              changeDate={changeDate}
              timeRange={timeRange}
              changeTimeRange={changeTimeRange}
              activeDate={activeDate}
              ifAnyStaffAvailable={transformSchedule.ifAnyStaffAvailable}
            />
            {transformSchedule.ifAnyStaffAvailable ? (
              <Fragment>
                {!tableLoader ? (
                  <StaffTable
                    timeHr={timeHr}
                    transformSchedule={transformSchedule}
                    submitSchedule={submitSchedule}
                    selectedDate={selectedDate}
                  />
                ) : (
                  <LoaderComponent />
                )}
              </Fragment>
            ) : (
              <Box component={"section"} className="section">
                <Box className="container">
                  <Grid container>
                    <Grid item xs>
                      <Typography
                        component={"h3"}
                        className="text-center page-description"
                      >
                        担当可能な相談員が不在です。
                        <br />
                        お手数ですが、別の日時をご選択ください。
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            )}

            {modalData && (
              <ReservationChangeModal
                modal={modal}
                loading={loading}
                setModal={setModal}
                modalData={modalData}
                changeReservationDate={changeReservationDate}
              />
            )}
            {!ticketNumber && (
              <div className="text-center mt-20">
                <button
                  className="secondary-btn"
                  onClick={() => {
                    navigate("/support/menu");
                  }}
                >
                  チケット選択に戻る
                </button>
              </div>
            )}
          </Container>
        ) : (
          <LoaderComponent />
        )}
        {errorModal && (
          <ErrorModal
            errorModal={errorModal}
            setErrorModal={setErrorModal}
            message={
              "予約できませんでした。お手数ですが、再度相談員と日時を選択してください"
            }
          />
        )}
        {staffAssignError && (
          <ErrorModal
            errorModal={staffAssignError}
            setErrorModal={setStaffAssignError}
            message={
              "予約できませんでした。お手数ですが、再度相談員と日時を選択してください"
            }
          />
        )}
      </Box>
    </Fragment>
  );
}
